import { IconButton, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

// Contextual help (Feature 4317 / N5): a "?" affordance in the top bar that
// deep-links to the most relevant Knowledge Base article for the current page,
// opening the Help Center in a new tab. Unmapped pages open the Help Center home.
//
// COUPLING: every `slug` below must match a published article slug in the KB
// seed (scripts/local-setup/postgres-seed/23-help-kb.sql in coronis-apps, and
// whatever seeds deployed envs). A mismatch fails SILENT — HelpCenter logs a
// console warning and falls back to its home view (no error, no broken link).
// If you rename a seeded article's slug, update the matching entry here.
const ARTICLE_BY_PATH: { test: RegExp; slug: string }[] = [
  { test: /^\/$/, slug: "welcome-to-the-aegle-claims-platform" },
  { test: /^\/clients/, slug: "understanding-clients" },
  { test: /^\/policies/, slug: "understanding-policies" },
  { test: /^\/claimants/, slug: "claimants-lasers-and-exclusions" },
  { test: /^\/stoploss-claims/, slug: "stop-loss-claims-and-claim-items" },
  { test: /^\/claim-items/, slug: "stop-loss-claims-and-claim-items" },
  { test: /^\/reimbursements/, slug: "understanding-reimbursements" },
  { test: /^\/tasks/, slug: "tasks-comments-and-notifications" },
  { test: /^\/documents/, slug: "documents-and-ai-extraction" },
];

export const HelpButton = () => {
  const { pathname } = useLocation();
  const match = ARTICLE_BY_PATH.find((m) => m.test.test(pathname));
  // Open the SPA fresh in a new tab at the Help Center hash route.
  const base = window.location.href.split("#")[0];
  const href = `${base}#/help${match ? `?article=${match.slug}` : ""}`;

  return (
    <Tooltip title={match ? "Help for this page" : "Help Center"}>
      <IconButton component="a" href={href} target="_blank" rel="noopener" size="small" aria-label="Help">
        <HelpOutline fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
